export default "__VITE_ASSET__BFGOwVyI__"